export default __webpack_public_path__ + "static/presse-bpong-preview-1ae89ddf3508a36db05299680650649d.jpg";